import React, { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { getProjects } from '@src/apis/project';
import theme from '@src/styles/theme';
import { PAGINATION_LIMIT_REQUEST } from '@src/constants';
import debounce from '@src/utils/debounce';
import { StyledProjectLayout } from './index.style';
import ProjectHeader from './ProjectHeader';
import ProjectInput from './ProjectInput';
import ProjectList from './ProjectList';
import ProjectOnMobile from './ProjectOnMobile';

const Project = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [projects, setProjects] = useState([]);
  const [searchProjects, setSearchProjects] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION_LIMIT_REQUEST);

  const handleSearchInputChange = (e) => setSearch(e.target.value);

  const fetchProjects = async (hasLoading) => {
    if (hasLoading) setLoading(true);
    const newParams = {
      search: search?.trim(),
      offset: page * rowsPerPage,
      limit: rowsPerPage,
      sort: 'updatedAt_desc',
    };
    const response = await getProjects(newParams);
    if (response && response.status) {
      const projectsResult = response.result.projects;
      if (search) {
        setSearchProjects(projectsResult);
      } else {
        setProjects(projectsResult);
      }

      setTotal(response.result?.metadata?.total || 0);
      setLoading(false);
    }
  };

  useEffect(() => {
    debounce(fetchProjects, 500)(search);
  }, [search]);

  useEffect(() => {
    fetchProjects(true);
  }, [page, rowsPerPage]);

  const handleDeleteSuccess = (projectId) => {
    setProjects(projects.filter((project) => project.id !== projectId));
    if (page !== 0) {
      setPage(0);
    } else {
      fetchProjects(false);
    }
  };

  if (isMobile) {
    return <ProjectOnMobile />;
  }

  return (
    <StyledProjectLayout>
      <ProjectHeader />
      <ProjectInput refetchProjects={fetchProjects} />
      <ProjectList
        projects={projects}
        searchProjects={searchProjects}
        loading={loading}
        handleSearchInputChange={handleSearchInputChange}
        onDeleteSuccess={handleDeleteSuccess}
        total={total}
        page={page}
        rowsPerPage={rowsPerPage}
        onChangePage={setPage}
        onChangeRowPage={setRowsPerPage}
        refetchProjects={fetchProjects}
        rowsPerPageOptions={[10, 25]}
        search={search}
      />
    </StyledProjectLayout>
  );
};

export default Project;
